'use strict';

import { getLoggedServingsOfRecipe } from '@utils/Meals';

/**
 * Calculate yield warnings for dishes
 *
 * @param {Array} dishes - Array of dish objects with main property
 * @param {Object} contents - Contents object with recipes/foods indexed by UUID
 * @param {Array} participants - Array of participant objects
 * @param {number} extraServings - Extra servings to add to total
 * @returns {Array<string>} Array of warning messages (empty if no warnings)
 */
export function calculateYieldWarnings(dishes, contents, participants, extraServings = 0) {
    const warnings = [];

    dishes.forEach(({main: dish}) => {
        const content = contents[dish.recipe_uuid || dish.food_uuid];
        if (!content) return;

        const servings = content.servings || 1;
        const totalServings = participants.reduce((sum, participant) => sum + (
            participant.uuid == 'USER' ? getLoggedServingsOfRecipe(dish, content) : participant.portion), 0);
        const scaling = totalServings > 0 ? Math.ceil((totalServings + extraServings) / servings) : (1 + extraServings);
        const totalYield = scaling * servings;
        const totalNeeded = totalServings + extraServings;

        if (totalYield > totalNeeded) {
            const dishName = contents[dish.recipe_uuid]?.title || contents[dish.food_uuid]?.name;
            warnings.push(`${dishName}: Scaled to ${totalYield} ${totalYield > 1 ? "servings" : "serving"} (${totalNeeded} ${totalNeeded > 1 ? "servings" : "serving"} needed)`);
        }
    });

    return warnings;
}
